import * as actionTypes from "../actionTypes/Index";
import { categoryInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...categoryInitialState };

export const appendUpdateCategories = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.categories, ...payload.categoriesData];
  }
  return payload.categoriesData.slice();
};

export default function categoryReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_CATEGORIES_LIST_INIT: {
      return Object.assign({}, state, {
        isFetchCategoryLoading: true,
        isFetchCategoryError: false,
        isCategoryAdded: false,
        isCategoryUpdated: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.GET_CATEGORIES_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isFetchCategoryLoading: false,
        categories: appendUpdateCategories(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_CATEGORIES_LIST_FAIL: {
      return Object.assign({}, state, {
        isFetchCategoryLoading: false,
        isFetchCategoryError: true,
        error: action.error,
      });
    }
    case actionTypes.FETCH_CATEGORIES_CITY_LIST_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isCategoryUpdated: false,
      });
    }
    case actionTypes.FETCH_CATEGORIES_CITY_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        categories: appendUpdateCategories(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.FETCH_CATEGORIES_CITY_LIST_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
      });
    }
    case actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
        categoryProducts: action.payload,
      });
    }
    case actionTypes.FETCH_CATEGORY_PRODUCTS_FOR_CITY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
      });
    }
    case actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.REORDER_CATEGORY_PRODUCTS_FOR_CITY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_CITY_LEVEL_CATEGORY_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCategoryUpdated: false,
        error: null,
        isCategoryAdded: false,
      });
    }
    case actionTypes.UPDATE_CITY_LEVEL_CATEGORY_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCategoryUpdated: true,
        coreCategories: [],
        isCoreCategoriesFetched: false,
      });
    }
    case actionTypes.UPDATE_CITY_LEVEL_CATEGORY_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCategoryUpdated: false,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
